var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1318,
    height: 800,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-45.25%",
    y1: "-88.077%",
    x2: "97.789%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F952C5",
    offset: "4.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-64.06%",
    y1: "-121.906%",
    x2: "97.789%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F952C5",
    offset: "4.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "111.373%",
    x2: "-24.893%",
    y2: "-55.159%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.681%",
    y1: "5.006%",
    x2: "145.861%",
    y2: "145.591%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.375%",
    y1: "-15.195%",
    x2: "91.754%",
    y2: "105.701%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    transform: "matrix(-1 0 0 1 834.817 0)",
    d: "M0 0h409.224l425.593 376v156.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    transform: "rotate(180 528.65 584)",
    d: "M0 367l641.153.138L1057.3 673.299V801z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#c)",
    strokeWidth: 17,
    cx: 704,
    cy: 563,
    r: 49
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    opacity: 0.558,
    transform: "rotate(45 1107.87 708.87)",
    x: 1088.87,
    y: 689.87,
    width: 38,
    height: 38,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    opacity: 0.503,
    transform: "rotate(45 1279.598 103.598)",
    x: 1251.598,
    y: 75.598,
    width: 56,
    height: 56,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    opacity: 0.558,
    transform: "rotate(45 934.627 63.627)",
    x: 918.627,
    y: 47.627,
    width: 32,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    opacity: 0.558,
    transform: "rotate(45 703.627 186.627)",
    x: 687.627,
    y: 170.627,
    width: 32,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    opacity: 0.387,
    transform: "rotate(45 1237.02 606.02)",
    x: 1228.521,
    y: 597.521,
    width: 17,
    height: 17,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.477 739.477v-16.5a5 5 0 0 1 10 0v16.5h16.5a5 5 0 0 1 0 10h-16.5v16.5a5 5 0 1 1-10 0v-16.5h-16.5a5 5 0 1 1 0-10h16.5z",
    fill: "url(#e)",
    opacity: 0.211,
    transform: "rotate(45 96.477 744.477)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDesktop);
export default __webpack_public_path__ + "static/media/bg-desktop.6824779f0b32ead7a24a1984c63ba7ca.svg";
export { ForwardRef as ReactComponent };